import { z } from "zod";
import { EVENT_TYPE, OUTCOME } from "../../../constants/eventLog.js";
import { eventLogBaseSchema } from "../base.js";
const caseClosedMetadataSchema = z
    .object({
    closedAt: z.union([z.string(), z.date()]).nullable(),
    closingNotes: z.string().nullable(),
    outcome: z.string().nullable(),
    closureEmailSend: z.boolean().optional(),
})
    .strict();
const caseReopenedMetadataSchema = z.object({}).strict();
export const caseEventSchemas = [
    eventLogBaseSchema
        .extend({
        eventType: z.literal(EVENT_TYPE.CASE_CLOSED),
        outcome: z.literal(OUTCOME.APPLIED),
        reasonCode: z.null().optional(),
        metadata: caseClosedMetadataSchema,
    })
        .strict(),
    eventLogBaseSchema
        .extend({
        eventType: z.literal(EVENT_TYPE.CASE_REOPENED),
        outcome: z.literal(OUTCOME.APPLIED),
        reasonCode: z.null().optional(),
        metadata: caseReopenedMetadataSchema,
    })
        .strict(),
];
//# sourceMappingURL=case.js.map